import format from 'date-fns/format'

/**
 * @brief Formats a date string into a human-readable format with the day, month, and year.
 *
 * @param dateString The date string to format.
 * @returns The formatted date string.
 */
export function formatDateProfile(dateString) {
  if (dateString) {
    const date = new Date(dateString)
    const dateFormatted = format(date, 'd MMMM yyyy')

    return dateFormatted
  }
  return ''
}

/**
 * @brief Formats a date string into a human-readable format according to UK standards, including the time zone.
 *
 * @param dateString The date string to format.
 * @returns The formatted date string in UK format.
 */
export function formatDateUK(dateString) {
  const date = new Date(dateString)
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  const ukTime = date.toLocaleDateString('en-GB', options)

  return ukTime
}

/**
 * @brief Sanitizes a datetime string by removing the letter T.
 *
 * @param datetimeString The datetime string to sanitize.
 * @returns The sanitized datetime string.
 */
export function sanitizeDatetime(datetimeString) {
  if (datetimeString) {
    return datetimeString.replace('T', ' ')
  }
  return ''
}

/**
 * @brief Formats a date string into a given format.
 *
 * @param dateString The date string to format.
 * @returns The formatted date string.
 */
export function formatDate(dateString, shape) {
  if (dateString) {
    const initialDate = new Date(dateString)
    if (Number.isNaN(initialDate.getTime())) return ''
    const dateFormatted = format(initialDate, shape)

    return dateFormatted
  }
  return ''
}

export function getCurrentUtcTimestamp() {
  return new Date().toISOString().replace(/\.\d{3}Z$/, 'Z')
}
